<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.initApp();
  },
  methods: {
    initApp() {
      console.log(`app version ${1}.${0}.${1}`)
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'NanumSquare', sans-serif;
}
</style>
